<template>
    <v-dialog :model-value="visible"
              :persistent="true"
    >
        <v-card :rounded="true"
                :border="true"
                :flat="true"
        >
            <v-card-title class="d-flex align-center">
                <v-icon icon="mdi-bullhorn" color="primary" class="mr-2" />
                {{ broadcast.title }}
            </v-card-title>
            <v-divider class="mt-3" />
            <v-card-text class="text-body-1">
                <div v-html="parsedBody" />
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary"
                       variant="tonal"
                       @click="onDismiss"
                >
                    OK
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup>
    import {ref, computed, onMounted, onBeforeUnmount, watch} from "vue";
    import {useRoute} from "vue-router";
    import {marked} from "marked";
    import EventBus from "@/services/eventBus";

    const route = useRoute();

    const visible = ref(false);
    const broadcast = ref({
        title: '',
        body: '',
    });
    const pending = ref(null);

    const parsedBody = computed(() => marked.parse(broadcast.value.body ?? ''));

    const boutRoutes = ['bout', 'locker-room', 'matchmaking'];

    function isInBout() {
        return boutRoutes.includes(route.name);
    }

    function onSystemBroadcast(data) {
        if (isInBout()) {
            pending.value = {title: data.title, body: data.body};
        } else {
            show(data);
        }
    }

    function show(data) {
        broadcast.value = {title: data.title, body: data.body};
        visible.value = true;
    }

    function onDismiss() {
        visible.value = false;
        broadcast.value = {title: '', body: ''};
    }

    watch(() => route.name, (newRoute, oldRoute) => {
        if (boutRoutes.includes(oldRoute) && ! boutRoutes.includes(newRoute) && pending.value) {
            show(pending.value);
            pending.value = null;
        }
    });

    onMounted(() => {
        EventBus.on('system-broadcast', onSystemBroadcast);
    });

    onBeforeUnmount(() => {
        EventBus.off('system-broadcast', onSystemBroadcast);
    });
</script>
